import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import hcMap from 'highcharts/modules/map';
import cities from './city.json';
hcMap(Highcharts);

const USACountryCityChart = (props) => {
    const { chartOptions, mapSeries } = props;
    const [mapData, setMapData] = useState(cities);
    const [mapOptions, setMapOptions] = useState(null);
    useEffect(() => {
        if (mapData) {
            const options = chartOptions;
            options.series[0].data = mapSeries;
            options['chart']['map'] = mapData;
            setMapOptions(options);
        }
    }, [mapData, mapSeries]);

    return (
        mapOptions ? (<HighchartsReact
            constructorType={'mapChart'}
            containerProps={{ style: { height: 'auto', width: '100%' } }}
            highcharts={Highcharts}
            options={mapOptions}
        />) : null
    );
};

export default USACountryCityChart;
